import { pdvInfoState } from "../states/PdvInfoState";
import { ReducerAction } from '../ReducerAction';
import { ActionType } from "../ActionsTypes";
import { Pdvinfo } from '../../../domain/models/PdvInfo';


export const pdvInfoReducer = (state = new pdvInfoState({
  pdvInfo: new Pdvinfo({})
}), action: ReducerAction) => {

  switch(action.type) {
    case ActionType.SET_PDV_INFO:
      return new pdvInfoState({
        ...state,
        pdvInfo: action.payload
      });

      default: return state;
  }
}